import oRequest from '@/libsV2/request.js';

const URL = {
    JOURNEY_INDEX: 'report/Journey/index',//用户旅程
    JOURNEY_SEARCH: 'report/Journey/search',//用户旅程 搜索
    JOURNEY_PROJECT: "report.Journey/project_items",//项目清单
    JOURNEY_PROJECT_TYPE: "report.Journey/get_project_type",//项目类型
    JOURNEY_PROJECT_DETAIL: "report.Journey/getProjectDetail",//项目详情
    PORTRAYAL_TOTAL_AREA: "report.Portrayal/new_totalarea",//面积分布
    PORTRAYAL_TOTAL_HOUSE: "report.Portrayal/new_housetype",//房屋类型
    PORTRAYAL_TOTAL_HALL: "report.Portrayal/new_hall",//户型
    PORTRAYAL_DISTRIBUTE_LIST: "report.Portrayal/distributeList",//区域分布全国
    PORTRAYAL_DISTRIBUTE: "report.Portrayal/distribute"//区域分布地图数据
    
}

export default {
    getJourneyIndex(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.JOURNEY_INDEX, oData)
    },
    getJourneySearch(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.JOURNEY_SEARCH, oData)
    },
    getJourneyProject(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.JOURNEY_PROJECT, oData)
    },
    getJourneyProjectType(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.JOURNEY_PROJECT_TYPE, oData)
    },
    getJourneyProjectDetail(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.JOURNEY_PROJECT_DETAIL, oData)
    },
    getPortrayalTotalarea(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.PORTRAYAL_TOTAL_AREA, oData)
    },
    getPortrayalTotalHouse(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.PORTRAYAL_TOTAL_HOUSE, oData)
    },
    getPortrayalTotalHall(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.PORTRAYAL_TOTAL_HALL, oData)
    },
    getPortrayalDistributeList(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.PORTRAYAL_DISTRIBUTE_LIST, oData)
    },
    getPortrayalDistribute(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.PORTRAYAL_DISTRIBUTE, oData)
    },
}